import {
  AUCTION_STATUS_NOT_STARTED,
  CANDIDATES_STATUS_SUCCESS,
} from "core/consts";
import { Auction } from "core/types";
import { Banner, BannerProps } from "ds/ui";
import { useCandidates } from "dsl/atoms/SearchCandidates";
import { useTranslations } from "translations";

type BannerConfig = {
  header: BannerProps["heading"];
  id: string;
  message: BannerProps["message"];
  severity: BannerProps["color"];
  show: () => boolean;
};

export default function PatientProfileStatusBanner({
  auction,
}: {
  auction: Auction;
}) {
  const translations = useTranslations();
  const { hasCandidates } = useCandidates();

  const bannerConfigs: BannerConfig[] = [
    {
      header: translations.patient.profileBanners.profileComplete.title,
      id: "patient_profile_complete",
      message: translations.patient.profileBanners.profileComplete.subtitle,
      severity: "success",
      show: () =>
        auction.assessment_completed === true &&
        auction.status === AUCTION_STATUS_NOT_STARTED,
    },
    {
      header: translations.patient.profileBanners.profileIncomplete.title,
      id: "patient_profile_incomplete",
      message: translations.patient.profileBanners.profileIncomplete.subtitle,
      severity: "danger",
      show: () => !auction.assessment_completed,
    },
    {
      header: translations.patient.profileBanners.noProviderFound.title,
      id: "no_candidates",
      message: translations.patient.profileBanners.noProviderFound.subtitle,
      severity: "warning",
      show: () =>
        auction.candidates_status === CANDIDATES_STATUS_SUCCESS &&
        hasCandidates === false,
    },
  ];

  const bannersToShow = bannerConfigs.filter((bannerConfig) =>
    bannerConfig.show(),
  );

  if (!bannersToShow.length) return null;

  return (
    <>
      {bannersToShow.map((bannerConfig) => (
        <span key={bannerConfig.id} data-testid={bannerConfig.id}>
          <div className="mb-5">
            <Banner
              color={bannerConfig.severity}
              heading={bannerConfig.header}
              message={bannerConfig.message}
            />
          </div>
        </span>
      ))}
    </>
  );
}
